import { forwardRef, useState } from 'react';
import {
  ControlInfo,
  Textarea,
  TextAreaContainer,
} from 'components/form/Control/ControlStyles';

interface Props extends React.ComponentPropsWithRef<'textarea'> {
  error?: string;
  maxLength?: number;
  onChange?: (e: any) => void;
  defaultValue?: any;
}

export const TextArea = forwardRef<HTMLTextAreaElement, Props>((props, ref) => {
  const { maxLength, onChange, defaultValue, error, ...otherProps } = props;
  const [charsLeft, setCharsLeft] = useState(
    (maxLength ?? 0) - (defaultValue?.length ?? 0)
  );

  const handleChange = (e: any) => {
    if (maxLength) {
      const chars = e.target?.value?.length ?? 0;
      setCharsLeft(maxLength - chars);
    }
    onChange?.(e);
  };

  return (
    <TextAreaContainer>
      <Textarea
        className={maxLength && charsLeft < 0 ? 'has-error' : ''}
        ref={ref}
        onChange={handleChange}
        {...otherProps}
      />
      {maxLength ? (
        <ControlInfo className={charsLeft < 0 ? 'has-error' : ''}>
          {`${charsLeft} characters remaining (maximum ${maxLength})`}
        </ControlInfo>
      ) : null}
    </TextAreaContainer>
  );
});
